<div class="fraud-container">
  <div class="fraud-img-container">
    <img
      src="assets\images\shield-warning.svg"
      alt="Shield icon with a red exclamation point in the middle"
      class="TODO: warning-shield-icon"
    />
  </div>
  <p class="fraud-warning">{{ labels?.stellar?.fraud?.warning }}</p>
  <p
    class="fraud-aware"
    [innerHTML]="labels?.stellar?.fraud?.pleaseBeAware"
  ></p>
  <p class="fraud-scenarios">{{ labels?.stellar?.fraud?.fraudScenarios }}</p>
  <ul class="fraud-scenarios-list">
    <li>{{ labels?.stellar?.fraud?.fraudBulletOne }}</li>
    <li>{{ labels?.stellar?.fraud?.fraudBulletTwo }}</li>
    <li>{{ labels?.stellar?.fraud?.fraudBulletThree }}</li>
  </ul>
  <p class="fraud-decide">{{ labels?.stellar?.fraud?.beforeDeciding }}</p>

  <div class="mg-step-actions-row">
    <button color="primary" mat-raised-button (click)="next.emit()">
      {{ labels?.stellar?.fraud?.agreeAndContinue }}
    </button>
  </div>
</div>
